import { ActivitiesTypes } from './types';

export const fetchActivities = () => ({
  types: [
    ActivitiesTypes.FETCH_ACTIVITIES_REQUEST,
    ActivitiesTypes.FETCH_ACTIVITIES_SUCCESS,
    ActivitiesTypes.FETCH_ACTIVITIES_FAILURE,
  ],
  promise: (client: any) => client.get('/companies_activities'),
});
